import cn from 'classnames';
import styles from './DetailList.module.css';

type Props = {
  className?: string;
  children: React.ReactNode;
};

/**
 * useful as a [`<dl/>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/dl), for when you want a
 * series of key value examples.
 */
export function DetailList({ className, children }: Props) {
  return (
    <table className={cn(styles.DetailList_table, className)}>
      <tbody>{children}</tbody>
    </table>
  );
}
